import usePageDataStore from '~/stores/usePageData';

export function usePageData() {
  const pageData = usePageDataStore().pageData;

  const pageUtagData = computed(() => usePageDataStore().pageUtagData);

  return {
    ...pageData,
    user: pageData?.authData,
    topLevelCategoryID: pageData?.product?.product?.identifier?.topLevelCategoryID || '',
    brandName: pageData?.product?.product?.detail?.brand?.name || '',
    killswitches: pageData?.product?.killswitches || {},
    xapiUrl: pageData?.product?.xapiUrl || '',
    pageUtagData,
    query: pageData?.envProps?.query,
    // experimentation: pageData?.experimentation, // this isn't used as far as i can tell, keeping this line for now
    // ...context, // this isn't used as far as i can tell, keeping this line for now
  };
}

export default usePageData;
